import { useEffect, useState } from 'react'
import { getAdminStatus } from '../service'

// Reuses /admin/status. UI gating only: the API enforces every admin-only action itself.
export default function useAdminStatus () {
  const [isAdmin, setIsAdmin] = useState(false)
  useEffect(() => {
    let live = true
    getAdminStatus()
      .then(result => { if (live) setIsAdmin(Boolean(result && result.is_admin)) })
      .catch(() => { if (live) setIsAdmin(false) })
    return () => { live = false }
  }, [])
  return isAdmin
}
